// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.post-card {
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 12px;
  margin: 10px 0;
  background-color: #fafafa;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.post-card h4 {
  margin: 0 0 10px;
}

.post-card img,
.post-card video {
  max-width: 100%;
  border-radius: 6px;
  margin-top: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/components/PostCard.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":[".post-card {\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  padding: 12px;\n  margin: 10px 0;\n  background-color: #fafafa;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.post-card h4 {\n  margin: 0 0 10px;\n}\n\n.post-card img,\n.post-card video {\n  max-width: 100%;\n  border-radius: 6px;\n  margin-top: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
